module.exports = "../study/imgs/maps/Nagano/S8/Climate/Temperture/Nagano_Temperture_GFDL_RCP85_Mid.png";